import styled from "styled-components";


export const FromContainer = styled.div`  
  width: 420px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
  box-sizing: border-box;  
  margin:0;  
  @media (max-width: 768px) {
    width: 100%;        
  }
`;

export const ColorCapturedContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  
`;
export const ColorCaptured = styled.div`
  width: 100%;
  height: 30px;  
  background-color: ${({ color }) => color};
`;

export const PaletteSection = styled.div`
  width: 100%;  
`;

export const PaletteGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(11, 1fr);
  gap: 10px;
  width: 100%;
`;

export const PaletteColor = styled.button<{ $color: string; $selected?: boolean }>`
  aspect-ratio: 1;
  border-radius: 50px;
  border: 2px solid ${({ $selected, $color }) => {
    if ($selected) return '#ffffff';
    const isLight = $color === '#ffffff' || $color.toLowerCase() === '#fff';
    return isLight ? 'rgba(0,0,0,0.15)' : 'transparent';
  }};  
  background-color: ${({ $color }) => $color};
  cursor: pointer;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  transition: transform 0.15s ease, box-shadow 0.12s ease;  
  transform: scale(${({ $selected }) => $selected ? '1.40' : '1'});
  &:hover {
    transform: scale(1.40);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const Section = styled.div`
  width: 100%;
  border-radius: 16px;
  border: 1px solid #2A2A2A;
  background: #020617;
  padding: 16px 16px 18px;
  box-sizing: border-box;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  
`;

export const SectionTitleLabel = styled.span`
  font-size: 11px;
  font-family: 'Inter', Arial, sans-serif;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9CA3AF;
`;

export const SectionSubtitle = styled.p`
  font-size: 13px;
  font-family: 'Inter', Arial, sans-serif;
  color: #D1D5DB;
  margin: 0;
`;

export const DividerText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-family: 'Inter', Arial, sans-serif;
  color: #4B5563;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #1F2933;
  }
`;

export const NoColorSelected = styled.div`
  width: 100%;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed #374151;
  background: rgba(15, 23, 42, 0.7);
  font-size: 13px;
  font-family: 'Inter', Arial, sans-serif;
  color: #6B7280;
  box-sizing: border-box;
`;

export const HelperText = styled.p`
  font-size: 12px;
  font-family: 'Inter', Arial, sans-serif;
  color: #6B7280;
  margin-top: -10px;
  padding:0;
`;

export const FooterActions = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;  
`;